import { useMemo } from "react"
import { useDateRanges } from "../utils/date-utils"
import { AGG_TYPES, AggregationType } from "../constants/charts"

export default function useAggregationGroups(
  dataAggTypeOnly?: AggregationType,
) {
  const { minAggType, maxAggType } = useDateRanges()

  const aggregationGroups = useMemo(
    () =>
      AGG_TYPES.filter(({ type }, index) => {
        // if data agg type is set in config, hide all other options
        if (dataAggTypeOnly) {
          return dataAggTypeOnly === type
        }
        // if min agg type is weekly, hide daily
        if (minAggType === AggregationType.WEEKLY && index === 0) {
          return false
        }
        // if max agg type is daily, hide weekly and monthly
        if (maxAggType === AggregationType.DAILY && index > 0) {
          return false
        }
        // if max agg type is weekly, hide monthly
        if (maxAggType === AggregationType.WEEKLY && index === 2) {
          return false
        }
        return true
      }),
    [minAggType, maxAggType, dataAggTypeOnly],
  )

  return aggregationGroups
}
